import { render, staticRenderFns } from "./FormRecipientForm.vue?vue&type=template&id=8e672a1c&scoped=true&"
import script from "./FormRecipientForm.vue?vue&type=script&lang=js&"
export * from "./FormRecipientForm.vue?vue&type=script&lang=js&"
import style0 from "./FormRecipientForm.vue?vue&type=style&index=0&id=8e672a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e672a1c",
  null
  
)

export default component.exports